export enum MISGetSettlementRequestActionType {
  loading = "MIS_GET_SETTLEMENT_REQUESTING",
  successful = "MIS_GET_SETTLEMENT_REQUESTED",
  failed = "MIS_GET_SETTLEMENT_REQUEST_FAILED",
}
